<template>
  <div>
    <highcharts ref="chart" :options="options" />
    <br />
    <b-table
      :striped="true"
      :narrowed="true"
      :hoverable="true"
      :data="values"
      :columns="columns"
    />
  </div>
</template>

<script>
import Travel from '@/models/carbon/Travel.js'
import '@/plugins/highcharts.js'

export default {
  name: 'TravelsAndVehiclesEmissionsBar',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    total: function () {
      let total = this.ghgi.emissions.vehicles.intensity.intensity
      total += this.ghgi.emissions.travels.intensity.intensity
      return total / 1000
    },
    values: function () {
      let i = 0
      let obj = {
        label: '<nobr>' + this.$t('emissions.t.co2e.short') + '</nobr>'
      }
      let objp = {
        label:
          '<nobr>' +
          this.$t('compGraphicsTravelsAndVehiclesEmissionsBar.label-4') +
          '</nobr>'
      }
      for (let category of this.categories) {
        obj[category] = '<nobr>' + this.intensities[i].toFixed(2)
        obj[category] += ' +/- ' + this.uncertainties[i].toFixed(2) + '</nobr>'
        objp[category] =
          ((this.intensities[i] / this.total) * 100).toFixed(2) + ' %'
        i += 1
      }
      return [obj, objp]
    },
    columns: function () {
      let columns = [
        {
          field: 'label',
          label: '',
          sticky: true
        }
      ]
      for (let category of this.categories) {
        columns.push({
          field: category,
          label: category,
          numeric: true
        })
      }
      return columns
    },
    intensities: function () {
      let intensities =
        this.ghgi.emissions.travels.transportations.intensity.map(
          (obj) => obj.intensity / 1000
        )
      intensities.push(this.ghgi.emissions.vehicles.intensity.intensity / 1000)
      return intensities
    },
    uncertainties: function () {
      let uncertainties =
        this.ghgi.emissions.travels.transportations.intensity.map(
          (obj) => obj.uncertainty / 1000
        )
      uncertainties.push(
        this.ghgi.emissions.vehicles.intensity.uncertainty / 1000
      )
      return uncertainties
    },
    uncertaintiesTable: function () {
      let series = []
      for (let i in this.ghgi.emissions.travels.transportations.intensity) {
        series.push([
          this.ghgi.emissions.travels.transportations.intensity[i].intensity /
            1000 -
            this.ghgi.emissions.travels.transportations.intensity[i]
              .uncertainty /
              1000,
          this.ghgi.emissions.travels.transportations.intensity[i].intensity /
            1000 +
            this.ghgi.emissions.travels.transportations.intensity[i]
              .uncertainty /
              1000
        ])
      }
      series.push([
        this.ghgi.emissions.vehicles.intensity.intensity / 1000 -
          this.ghgi.emissions.vehicles.intensity.uncertainty / 1000,
        this.ghgi.emissions.vehicles.intensity.intensity / 1000 +
          this.ghgi.emissions.vehicles.intensity.uncertainty / 1000
      ])
      return series
    },
    categories: function () {
      return [].concat(
        Travel.transportations.map((value) => this.$t(value)),
        this.$t('compGraphicsTravelsAndVehiclesEmissionsBar.label-1')
      )
    },
    options: function () {
      return {
        title: {
          text: ''
        },
        series: [
          {
            type: 'column',
            data: this.intensities,
            showInLegend: false,
            tooltip: {
              pointFormat: '<b>{point.y} ' + this.$t('t.co2e') + '</b>',
              valueDecimals: 2
            }
          },
          {
            name: this.$t('compGraphicsTravelsAndVehiclesEmissionsBar.label-2'),
            type: 'errorbar',
            lineWidth: 2,
            data: this.uncertaintiesTable,
            tooltip: {
              pointFormat:
                ' (' +
                this.$t('compGraphicsTravelsAndVehiclesEmissionsBar.label-3') +
                ': {point.low} - {point.high} ' +
                this.$t('t.co2e') +
                ')<br/>',
              valueDecimals: 2
            }
          }
        ],
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('emissions.t.co2e.short')
          }
        },
        tooltip: {
          shared: true
        }
      }
    }
  }
}
</script>

<style>
.is-sticky {
  background: #fafafa !important;
}
.table td {
  vertical-align: middle !important;
}
</style>
